import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
export type LegalType = 'privacy' | 'terms';
type Props = {
  type: LegalType | null;
  onClose: () => void;
};
export function LegalModal({
  type,
  onClose
}: Props) {
  const {
    t
  } = useLang();
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (type) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [type, onClose]);
  const data = type ? t.legal[type] : null;
  return <AnimatePresence data-id="element-273" data-mp="1hsvhnaryobjo">
      {data && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-label={data.title} data-id="element-274" data-mp="1hrkar237ynoc">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-dark-100 border border-white/10 rounded-3xl w-full max-w-2xl max-h-[85vh] flex flex-col shadow-2xl" data-id="element-275" data-mp="1pmo0inuvd588">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-white/10 shrink-0" data-id="element-276" data-mp="67cl1x2g1ksi">
              <h2 className="text-2xl font-bold text-white" data-id="element-277" data-mp="19b53l0be1l9">{data.title}</h2>
              <button onClick={onClose} aria-label={t.legal.close} className="w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-white/10 transition-colors" data-id="element-278" data-mp="fxo0ogvhpif8">
                <X className="w-5 h-5" data-id="element-279" data-mp="3jewdunf9vu3m" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto p-6 space-y-6" data-id="element-280" data-mp="3eh4dd50kaznt">
              {data.sections.map((section, i) => <div key={i} data-id="element-281" data-mp="3ta7lkls9k11v" data-mpi={i}>
                  <h3 className="text-gold font-bold mb-2" data-id="element-282" data-mp="3ocy0tjftkdkd">
                    {section.heading}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-283" data-mp="18la5fsgget3o">
                    {section.body}
                  </p>
                </div>)}
              <p className="text-gray-600 text-xs pt-4 border-t border-white/5" data-id="element-284" data-mp="1b7135njk5yh1">
                {t.legal.lastUpdated}
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}